import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const isChatAvailable: TComputedPropMapper<boolean> = ({ offer, user }): boolean => {
  const { user: offerUser, chat: offerChat } = offer;

  return Boolean(offerChat?.canSendMessage) && (!user.isAuthenticated || Number(offerUser?.cianUserId) !== user.id);
};
